import i18n from "@/i18n";

export default [
  {
    path: "/invoice",
    alias: ["/unpaid", "/quotationV", "/amends", "/refund"], // 兼容旧路由
    name: "Invoice",
    component: () => import("@/pages/invoice/invoice.vue"),
    meta: {
      title: i18n.messages[i18n.locale].invoice.common.generalInvoice,
    },
  },
  {
    path: "/batchPrintInvoice",
    name: "BatchPrintInvoice",
    component: () => import("@/pages/batchPrint/index.vue"),
    meta: {
      title: "Batch printing invoices",
      requireAuth: true,
    },
  },
];
